import env from "flow/configuration/environment";
import ICLICommand from "flow/interfaces/ICLICommand";

export default {
    name: "set",
    description: "Sets an environment variable",
    options: [],
    arguments: [
        {
            name: "key",
            description: "The key to store the value in.",
            type: "string",
            mandatory: true
        },
        {
            name: "value",
            description: "The value to be stored.",
            mandatory: true
        }
    ],
    callback: (writer, optsAndArgs) => {
        let value = optsAndArgs.value;

        // Make boolean if it matches exactly
        if (value === "true") {
            value = true;
        } else if (value === "false") {
            value = false;
        } else if (!isNaN(value)) {
            // Make number if it can be parsed completely
            value = parseInt(value);
        }

        try {
            env.set(optsAndArgs.key, value);
            writer.output.writeLine(optsAndArgs.key + " set to " + value);
        } catch (e) {
            writer.error.writeLine(e.message);
        }

        return { input: "" };
    }
} as ICLICommand;
